export default __webpack_public_path__ + "static/media/banner.8d89c978.jpg";